/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateRackPlaceRequest { 
    id?: string | null;
    number?: number;
    subnet?: string | null;
    socketTypeId?: number;
}

